var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-col',{attrs:{"span":24}},[_c('a-row',{staticClass:"max1200"},[_c('a-row',{staticClass:"content"},[_vm._t("content")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }